import { Dispatcher } from 'barba.js';

Dispatcher.on('initStateChange', function({ url }) {

	const $headerNav = $('#header-nav');
	const $navLinks = $headerNav.find('a');
	const toggler = $headerNav.data('toggler');

	// Give it some time before closing to improve UX
	setTimeout(() => toggler.close(), 400);

	$navLinks.removeClass('is-uri is-descendant-uri');
	$navLinks.filter(`[href="${url}"]`).addClass('is-uri');
	// TODO Descendant URI classes should be added... but it's a lot of work for something that would go unnoticed.
});



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js